import type { TourStep } from '../types';

export const managingEngagementsSteps: TourStep[] = [
  {
    target: '[data-tour="engagement-log-header"]',
    title: 'Your Engagement Log',
    content:
      'The Engagement Letter Log gives you a single view of every engagement letter across all stages — draft, pending, and executed.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="engagement-log-stats"]',
    title: 'Spot Bottlenecks',
    content:
      'These counters update in real time. If you see a lot of letters stuck in "Pending," it may be time to follow up with clients on outstanding signatures.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="engagement-log-search"]',
    title: 'Search Your Letters',
    content:
      'Find any engagement letter by typing the property address, client name, or city. The list filters as you type. Try searching for something.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve tried searching',
  },
  {
    target: '[data-tour="engagement-log-list"]',
    title: 'Status Badges & Retention',
    content:
      'Each letter shows its status badge — Draft, Pending Client, Pending Appraiser, or Executed. Executed and pending letters can\'t be deleted per USPAP record retention requirements. "Ready to Start" badges appear on executed letters that can be converted to appraisals.',
    placement: 'top',
  },
];
